var React = require('react');

function Smoke (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.8247 101.914C26.8247 101.914 34.2905 81.6646 55.3044 85.0118C55.3044 85.0118 61.4345 86.4361 67.9223 92.703C74.4101 98.97 115.15 96.0502 113.647 61.1546C113.647 61.1546 145.085 64.4067 142.89 33.8078C142.89 33.8078 138.859 8.88239 111.286 16.7398C111.286 16.7398 112.789 3.11393 98.8349 0.336525C84.8813 -2.41714 80.7549 12.6331 80.7549 12.6331C80.7549 12.6331 71.4286 -6.42892 46.2166 4.51452C46.2166 4.51452 27.1348 16.2176 36.8904 35.1372C36.8904 35.1372 15.7095 29.3687 4.68968 45.5821C-6.33011 61.8192 14.5169 79.7893 14.5169 79.7893C14.5169 79.7893 1.27884 85.8901 0.0385132 101.866C-1.17795 117.89 26.8247 101.914 26.8247 101.914Z","fill":"white"}));
}

Smoke.defaultProps = {"width":"143","height":"109","viewBox":"0 0 143 109","fill":"none"};

module.exports = Smoke;

Smoke.default = Smoke;
